import { AssetFieldModel } from "./asset_field.model";
import { ObservationModel } from "./observation.model";
import { FileModel } from "./file.model";
import { ConditionReportModel } from "./condition-report.model";
import { RepairModel } from "./repair.model";
import { HistoryModel } from "./history.model";
import { AssetTypeModel } from "./asset-type.model";

export class AssetModel {

  uid: number;
  name: string;
  assetType: AssetTypeModel;
  jobAssetUid: number;
  fields: Array<AssetFieldModel> = [];
  hasImages: boolean;
  organisationUid: number;
  locationUid: number;
  recommededBreakdowns: any = [];
  repairBreakdowns: any = [];
  conditionReport: ConditionReportModel;
  powerIssue: boolean;
  shortDescription: string;
  longDescription: string;
  lastJobDateTime: string;
  lastReportDateTime: string;
  locationLatitude: string;
  locationLongitude: string;
  locationName: string;
  assetLatitude: string;
  assetLongitude: string;
  photos: Array<FileModel> = [];
  observations: Array<ObservationModel> = [];
  repairs: Array<RepairModel> = [];
  history: Array<HistoryModel> = [];

  constructor() {

  }
}